export const base64ToBlob = (base64, type = 'application/pdf') => {
    const cleanBase64 = base64.includes(',') ? base64.split(',')[1] : base64
    const binary = atob(cleanBase64)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
    }
    return new Blob([bytes], { type })
}   
